/* Native Coming Soon */
(() => {
  const updateLaunchCountdowns = (root = document) => {
    const now = Date.now();

    root.querySelectorAll("[data-product-launch-countdown]").forEach((countdown) => {
      const releaseTime = Number(countdown.dataset.comingSoonRelease) * 1000;
      const distance = Math.max(releaseTime - now, 0);
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      const setValue = (selector, value) => {
        const element = countdown.querySelector(selector);
        if (element) element.textContent = String(value).padStart(2, "0");
      };

      setValue("[data-countdown-days]", days);
      setValue("[data-countdown-hours]", hours);
      setValue("[data-countdown-minutes]", minutes);
      setValue("[data-countdown-seconds]", seconds);
    });
  };

  const initialiseComingSoon = (root = document) => {
    updateLaunchCountdowns(root);
    const now = Math.floor(Date.now() / 1000);
    const releaseTimes = Array.from(root.querySelectorAll("[data-coming-soon-release]"))
      .map((element) => Number(element.dataset.comingSoonRelease))
      .filter((timestamp) => Number.isFinite(timestamp) && timestamp > now);

    if (releaseTimes.length === 0 || window.comingSoonReloadTimer) return;

    const nextRelease = Math.min(...releaseTimes);
    const delay = Math.min((nextRelease - now) * 1000 + 500, 2147483647);
    window.comingSoonReloadTimer = window.setTimeout(() => window.location.reload(), delay);
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-coming-soon-notify]");
    if (!button) return;

    const formId = button.dataset.klaviyoFormId;
    if (!formId) {
      console.warn("Coming Soon: add the Klaviyo form ID in Theme settings.");
      return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", formId]);
  });

  document.addEventListener("submit", (event) => {
    if (event.target.querySelector?.("[data-coming-soon-notify]")) {
      event.preventDefault();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialiseComingSoon());
  } else {
    initialiseComingSoon();
  }

  document.addEventListener("shopify:section:load", (event) => initialiseComingSoon(event.target));
  window.setInterval(() => updateLaunchCountdowns(), 1000);
})();
/* Native Coming Soon */